<div class="form-modal" style="width: 1024px">
  <h1 mat-dialog-title>
    <div class="row">
      <div class="col-xs-6 text-left">
        {{'DISTRIBUTION' | translate}} - {{totalNetAmountString}} <i matSuffix class="fas fa-euro-sign"></i>
      </div>
      <div class="col-xs-6 text-right" *ngIf="!isDisabled">
        <button
          type="button"
          class="btn mb-0 text-black"
          title="{{'ADD' | translate}}"
          (click)="add()">
          <i class="fas text-primary fa-plus"></i>&nbsp;{{'ADD' | translate}}
        </button>
      </div>
    </div>
  </h1>
  <form [formGroup]="form" class="form-horizontal" (keydown.enter)="$event.preventDefault()">

    <div mat-dialog-content>
      <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
        <div *ngIf="form" class="table table-bordered display" cellspacing="0">
          <table>
            <thead>
              <tr>
                <th width="25%">
                  <strong>{{'COSTCENTER'|translate}}</strong>
                </th>
                <th width="25%" *ngIf="showElement">
                  <strong>{{'RUBRIC'|translate}}</strong>
                </th>
                <th width="25%" *ngIf="showRubric">
                  <strong>{{'ELEMENT'|translate}}</strong>
                </th>
                <th width="10%" class="text-right">
                  <strong>{{'PERCENTAGE'|translate}}</strong>
                </th>
                <th width="10%" class="text-right">
                  <strong>{{'VALUE'|translate}}</strong>
                </th>
                <th *ngIf="!isDisabled" width="5%"></th>
              </tr>
            </thead>
            <tbody formArrayName="CostCenterDistribution">
              <ng-container *ngIf="form?.controls?.CostCenterDistribution.length > 0; else noResultsCostCenterConfig" >
                <tr *ngFor="let item of form?.controls?.CostCenterDistribution.controls; let i=index" [formGroupName]="i">
                  <td width="25%">
                    <mat-form-field class="allwidth">
                      <input matInput placeholder="{{ 'COST_CENTER' | translate}}"
                        formControlName="CostCenterName" class="one" readonly>
                        <i matSuffix *ngIf="this.form.get('CostCenterDistribution').controls[i].get('CostCenterID').enabled" class="glyphicon glyphicon-new-window one link" (click)="selectCostCenter(i)"></i>
                    </mat-form-field>
                  </td>
                  <td *ngIf="showRubric" width="25%">
                    <mat-form-field class="allwidth">
                      <mat-select placeholder="{{ ('RUBRIC' | translate) }}" formControlName="RubricID">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let e of rubricaList[i]" [value]="e.ID">
                          {{e.ItemName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="showElement" width="25%">
                    <mat-form-field class="allwidth">
                      <mat-select placeholder="{{ ('ELEMENT' | translate) }}" formControlName="ElementID">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let e of elementoList[i]" [value]="e.ID">
                          {{e.ItemName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth" width="10%">
                      <input matInput formControlName="Percentage" (change)="onChangePercentage($event.target.value, i)"
                        class="no-padding-left text-right">
                      <i matSuffix class="fas fa-percentage"></i>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth" width="10%">
                      <input matInput formControlName="Value" (change)="onChangeValue($event.target.value, i)"
                        class="no-padding-left text-right">
                      <i matSuffix class="fas fa-euro-sign"></i>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isDisabled" class="text-center" width="5%">
                    <button type="button" class="btn btn-sm" (click)="remove(i)">
                      <span title="{{'BUTTON.DELETE' | translate}}">
                        <i class="far fa-trash-alt color-danger backwhite"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <ng-template  #noResultsCostCenterConfig>
                <tr>
                  <td [colSpan]="10" class="text-center">{{ 'NO_RESULTS_WERE_FOUND' | translate }}</td>
                </tr>
              </ng-template>
            </tbody>
            <tfoot class="border-top-foot">
              <tr>
                <th colspan="3" class="text-right">{{'TOTAL' | translate}}:</th>
                <td class="text-right">
                  <span [ngClass]="form.controls.SumPercentageNumber.value == 100 ? 'green' : 'red'">{{form.controls.SumPercentage.value}}</span>
                  <i matSuffix class="fas fa-percentage"></i>
                </td>
                <td class="text-right">
                  <span [ngClass]="form.controls.SumValue.value === totalNetAmountString ? 'green' : 'red'">{{form.controls.SumValue.value}}</span>
                  <i matSuffix class="fas fa-euro-sign"></i>
                </td>
                <td *ngIf="!isDisabled"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div mat-dialog-actions>

      <div class="full-width display-flex">
        <div class="full-width">
          <button *ngIf="!isDisabled" type="button" class="btn btn-default" title="{{'RECALCULATE' | translate}}" (click)="recalc(true)">
            {{'RECALCULATE' | translate}} €
          </button>

          <button *ngIf="!isDisabled" type="button" class="btn btn-default" title="{{'RECALCULATE' | translate}} €" (click)="recalc(false)">
            {{'RECALCULATE' | translate}} %
          </button>
        </div>
  
        <div class="full-width text-right">
          <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
            {{'BUTTON.CANCEL' | translate}}
          </button>
          <button *ngIf="!isDisabled" type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}" (click)="onSubmit()">
            {{'BUTTON.SAVE' | translate}}
          </button>
        </div>
      </div>
     
    </div>
  </form>
</div>